// HEAL-47 — экран вместо белого.
//
// Требование тикета дословно: «белый экран без сообщения недопустим». Здесь важны
// не столько слова, сколько ВЫХОДЫ. Исходная жалоба: переустановка приложения не
// помогает, потому что падение вызвано данными аккаунта на сервере, а не кэшем на
// устройстве. Поэтому кнопок две:
//   «Попробовать снова» — перерисовать поддерево (сетевой сбой, разовая гонка);
//   «Выйти из аккаунта» — единственный выход, когда падение воспроизводится на
//   каждом входе: пользователь хотя бы попадёт на экран входа и сможет зайти
//   другим аккаунтом, а не останется с кирпичом.

import { AlertTriangle } from 'lucide-react';

import { MobileFrame } from '@/components/layout/MobileFrame';
import { Button } from '@/components/ui/button';
import { clearToken } from '@/lib/auth-storage';
import { clearMarkerNavState } from '@/lib/markerNavState';

export function AppCrashView({ onRetry }: { onRetry: () => void }) {
  async function handleSignOut() {
    try {
      clearMarkerNavState();
      await clearToken();
    } catch {
      // Даже если чистка не удалась — уводим на вход. Застрять здесь хуже.
    }
    // Именно перезагрузка, а не router-навигация: дерево React уже в сломанном
    // состоянии, доверять ему переход нельзя.
    window.location.replace('/signin');
  }

  return (
    <MobileFrame>
      <div className="flex flex-1 flex-col items-center justify-center gap-4 px-8 text-center">
        <div className="flex h-14 w-14 items-center justify-center rounded-full bg-red-50 text-red-600">
          <AlertTriangle className="h-7 w-7" aria-hidden />
        </div>
        <h1 className="text-lg font-bold">Что-то пошло не так</h1>
        <p className="text-sm leading-relaxed text-muted-foreground">
          Экран не удалось открыть. Ваши данные на месте — сбой произошёл при отображении.
        </p>
        <div className="mt-2 w-full space-y-2">
          <Button type="button" onClick={onRetry} className="w-full">
            Попробовать снова
          </Button>
          <Button type="button" variant="outline" onClick={handleSignOut} className="w-full">
            Выйти из аккаунта
          </Button>
        </div>
        <p className="text-hl-small leading-snug text-gray-400">
          Если экран появляется снова — напишите нам, мы уже видим причину в логах.
        </p>
      </div>
    </MobileFrame>
  );
}
